
import CookieHelper from '../../common/helpers/cookieHelper'
import { model } from '../core/model'
import { Config } from '../core/config'
import metering from '../helpers/metering'
import urlHelper from '../helpers/url'

const Verify = (onContinue) => {
    let cookieMetering = CookieHelper.readCookie(Config.COOKIE_METERING)
    let consumidas = CookieHelper.readCookie(Config.COOKIE_COUNTER)
    if (consumidas < model.Usuario.Cuota && metering.IsDisallow(cookieMetering)){
        onRedirect();
        return;
    }

    onContinue()  
}


const onRedirect = () =>{
    //Borro el disallow
    CookieHelper.deleteCookieName(Config.COOKIE_METERING);
    //vuelvo a la nota (si tiene)
    urlHelper.returnBack()
}

export default Verify;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/cuotaFalsa.js